import React from "react";
import CustomModal from "./CustomModal";
import { t } from "i18next";

const ConfirmDialog = (props) => {
  const { showModal, setShowModal, confirmLogout, modalTitle } = props;

  return (
    <CustomModal centered={true} show={showModal}>
      <div className="logout-modal-confirmation">
        <div className="logout-modal-confirmation-context">
          <img
            src="/images/lg-logo.png"
            className="img-fluid logout-modal-confirmation-image"
            alt="LG"
          />
          <div className="logout-modal-confirmation-title">{modalTitle}</div>
        </div>
        <div className="logout-modal-confirmation-button">
          <div
            className="logout-modal-confirmation-button-item"
            onClick={() => confirmLogout()}
          >
            <div className="logout-modal-confirmation-button-item-text">
              {t("yes")}
            </div>
          </div>
          <div
            className="logout-modal-confirmation-button-item colored"
            onClick={() => setShowModal(false)}
          >
            <div className="logout-modal-confirmation-button-item-text">
              {t("no")}
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default ConfirmDialog;
